import { useState } from 'react';
import type { JSX } from 'react';
import { useIntl } from 'react-intl';
import { Text } from '@atlaskit/primitives/compiled/text';
import { SpotlightActions } from '@atlaskit/spotlight/actions';
import { SpotlightBody } from '@atlaskit/spotlight/body';
import { SpotlightCard } from '@atlaskit/spotlight/card';
import { SpotlightControls } from '@atlaskit/spotlight/controls';
import { SpotlightDismissControl } from '@atlaskit/spotlight/dismiss-control';
import { SpotlightFooter } from '@atlaskit/spotlight/footer';
import { SpotlightHeader } from '@atlaskit/spotlight/header';
import { SpotlightHeadline } from '@atlaskit/spotlight/headline';
import { PopoverContent } from '@atlaskit/spotlight/popover-content';
import { SpotlightPrimaryAction } from '@atlaskit/spotlight/primary-action';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { registeredContent } from './content';

export const ReleaseDateSpotlight = (): JSX.Element => {
	const [isVisible, setIsVisible] = useState(true);
	const { formatMessage } = useIntl();
	const { onAcknowledged, onClosed } = usePostOfficeUserInteractions();
	const messages = registeredContent.default;
	const dismiss = () => {
		setIsVisible(false);
		onClosed({ interactionIdentifier: 'dismiss' });
	};
	const acknowledge = () => {
		setIsVisible(false);
		onAcknowledged({ interactionIdentifier: 'got-it' });
	};
	return (
		<PopoverContent
			isVisible={isVisible}
			placement="bottom-end"
			dismiss={dismiss}
			done={acknowledge}
			shouldDismissOnClickOutside={false}
		>
			<SpotlightCard>
				<SpotlightHeader>
					<SpotlightHeadline>{formatMessage(messages.title)}</SpotlightHeadline>
					<SpotlightControls>
						<SpotlightDismissControl />
					</SpotlightControls>
				</SpotlightHeader>
				<SpotlightBody>
					<Text>{formatMessage(messages.description)}</Text>
				</SpotlightBody>
				<SpotlightFooter>
					<SpotlightActions>
						<SpotlightPrimaryAction>{formatMessage(messages.primaryAction)}</SpotlightPrimaryAction>
					</SpotlightActions>
				</SpotlightFooter>
			</SpotlightCard>
		</PopoverContent>
	);
};
